import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getMeetApprovedRequest from './GetMeetApprovedRequestData';
import getApprovedMeetWorkflow from '../GetWorkFlowByIdData';
import putApprovedMeetWorkflow from '../PutWorkFlowData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const MeetApprovedRequestData = {
  INITIAL_STATE,
  getMeetApprovedRequest,
  getApprovedMeetWorkflow,
  putApprovedMeetWorkflow
};

export default MeetApprovedRequestData;